import * as React from 'react'
import PromotionalCards from '../../molecules/promotional-cards'
import * as actions from '../../../actions'
import { RouteComponentProps, withRouter } from 'react-router'
import { GetFirstDashCampaignsSuccessPayload } from '../../../api'
import { Application } from 'src/utilities/application/application'
import * as DA from '../../../typeModules/events'
import { connect } from 'react-redux'
import { CardContent, CardTypes } from '../../molecules/promotional-cards/Card'
import cardStrings from '../../pages/get-started-promotions/strings'
import { isEmpty } from 'lodash'
import {
  getHourlyPayFromPromotionalCards,
  mapCampaignsToPromotionalCards,
  shouldShowHourlyPay,
} from '../../pages/get-started-promotions/util'
import {
  Text,
} from '@doordash/design-language'
import Loading from '@doordash/component-loading'
import * as events from '../../../events'

type Props = {
  uniqueLink: string
  application?: Application
  getPromotionalCards?: (
    uniqueLink: string
  ) => Promise<GetFirstDashCampaignsSuccessPayload[]>
  trackPromotionsProfileSetup?: <T>(
    ...args: (DA.EventActions | T | object)[]
  ) => Promise<void>
  firstDashCampaigns?: GetFirstDashCampaignsSuccessPayload[]
}

const processPromotionalCards = (firstDashCampaigns): CardContent[] => {
  const defaultCards: CardContent[] = [
    {
      title: cardStrings.promoCardDefaultTitleAlt(),
      content: cardStrings.promoCardDefaultContentAlt(),
      type: CardTypes.Default,
    },
  ]

  if (isEmpty(firstDashCampaigns)) {
    return [...defaultCards]
  }

  const monetaryFields = getHourlyPayFromPromotionalCards(firstDashCampaigns)
  const unitAmount = (monetaryFields && monetaryFields.unitAmount) || 0

  // Exclude Hourly Pay cards if should not show based on condition
  const mappedCards = mapCampaignsToPromotionalCards(
    firstDashCampaigns,
    !shouldShowHourlyPay(unitAmount) ? [CardTypes.HourlyPay] : [],
    defaultCards[0]
  )

  return [...mappedCards, ...defaultCards]
}

export const WrappedExcitementProfile: React.FC<Props> = ({
  uniqueLink,
  getPromotionalCards,
  trackPromotionsProfileSetup,
  firstDashCampaigns,
}) => {
  const [promotionalCards, setPromotionalCards] = React.useState([])
  const [
    isLoadingFirstDashCampaigns,
    setIsLoadingFirstDashCampaigns,
  ] = React.useState(true)

  React.useEffect(() => {
      try {
        if (isLoadingFirstDashCampaigns) getPromotionalCards(uniqueLink)
      } finally {
        setIsLoadingFirstDashCampaigns(false)
      }

  }, [getPromotionalCards, isLoadingFirstDashCampaigns, promotionalCards, uniqueLink])

  React.useEffect(() => {
    setPromotionalCards(processPromotionalCards(firstDashCampaigns))
  }, [firstDashCampaigns])

  return (isLoadingFirstDashCampaigns ? <Loading /> : <div>
    <PromotionalCards
      swipeable={true}
      styleVariant={PromotionalCards.Type.LargeTitle}
      cards={promotionalCards}
      shouldDisplayIcons={false}
      cardHeightPx={200}
      track={trackPromotionsProfileSetup}
      autoScrollMs={5000}
    />
    <Text
      styles={Text.Styles.Caption2}
      color={Text.Colors.TextTertiary}
    >
      {cardStrings.legalDisclaimer()}
    </Text>
  </div>
  )
}

const mapStateToProps = state => ({
  application: state.application,
  experiments: state.experiments,
  firstDashCampaigns: state.firstDashCampaigns,
})
const mapDispatchToProps = {
  getPromotionalCards: actions.getPromotionalCards,
  trackPromotionsProfileSetup: events.trackPromotionsProfileSetup,
}
export default withRouter<Props & RouteComponentProps<{}>>(
  connect(mapStateToProps, mapDispatchToProps)(WrappedExcitementProfile)
)
